import React from 'react'
import { useSubPages } from '../uses/useSubPages'
import Cross from './Cross'
import Brio from './Brio'

// comptes.js page
import Bilan from './Bilan'
import PP from './PP'
import Repartition from './Repartition'
import Reserve from './Reserve'
import Annexe from './Annexe'
import Audit from './Audit'

// ressources-humaines.js page
import Absenteisme from './graphs/Absenteisme'
import Age from './graphs/Age'
import Rotation from './graphs/Rotation'
import Occupation from './graphs/Occupation'
import Anciennete from './graphs/Anciennete'
import Satisfaction from './graphs/Satisfaction'
import Blocks from './Blocks'
import Formation from './graphs/Formation'

// prestations.js page
import SoinsPaliatifs from './SoinsPaliatifs'

export const AccordionContext = React.createContext('accordion')

class AccordionItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      slug: null,
    }
  }

  toggleAccordion() {
    const { page } = this.props
    if (this.getSlug() === page.slug) {
      history.pushState('', document.title, window.location.pathname)
      this.setState({ slug: null })
    } else {
      window.location.hash = page.slug
      this.setState({ slug: page.slug })
    }
  }

  getSlug = () => window.location.hash.replace('#', '')

  componentDidMount() {
    if (window) {
      const slug = this.getSlug()
      this.setState({ slug })
      window.location.hash = slug
    }
  }

  UNSAFE_componentWillReceiveProps() {
    if (window) {
      const slug = this.getSlug()
      this.setState({ slug })
    }
  }

  render() {
    const { page, children } = this.props
    const { slug } = this.state

    const getIcon = page => {
      if ([27, 227, 229, 231, 233, 235].indexOf(page.wordpress_id) !== -1) {
        return 'icon-table'
      }
      if ([40, 42, 45, 49, 51, 47, 408].indexOf(page.wordpress_id) !== -1) {
        return 'icon-graph'
      }

      if ([237].indexOf(page.wordpress_id) !== -1) {
        return 'icon-download'
      }

      return 'icon-folder'
    }

    return (
      <React.Fragment>
        <div className="accordion-anchor" />
        <article className={`accordion-item ${page.slug}`}>
          <div
            onClick={() => this.toggleAccordion()}
            className={`accordion-header ${slug === page.slug ? 'active' : ''}`}
          >
            <div className="item-icon">
              <i className={getIcon(page)} />
            </div>
            <div className="item-title">
              <h2
                id={page.slug}
                dangerouslySetInnerHTML={{ __html: page.title }}
              />
            </div>
            <div className="item-trigger-content">
              <Cross />
            </div>
          </div>
          <AccordionContext.Provider value={slug}>
            {children}
          </AccordionContext.Provider>
        </article>
      </React.Fragment>
    )
  }
}

const ItemContent = ({ page }) => {
  switch (page.slug) {
    case 'brio':
      return <Brio page={page} />
    case 'bilan':
      return <Bilan />
    case 'compte-dexploitation':
      return <PP />
    case 'propositions-daffectations':
      return <Repartition />
    case 'reserves-affectations':
      return <Reserve />
    case 'index-aux-comptes':
      return <Annexe />
    case 'age':
      return <Age page={page} />
    case 'absenteisme':
      return <Absenteisme page={page} />
    case 'taux-de-rotation':
      return <Rotation page={page} />
    case 'taux-doccupation':
      return <Occupation page={page} />
    case 'anciennete':
      return <Anciennete page={page} />
    case 'indicateurs-de-satisfactions':
      return <Satisfaction page={page} />
    case 'rapport-audit':
      return <Audit page={page} />
    case 'formations':
      return <Formation page={page} />
    case 'soins-palliatifs':
      return <SoinsPaliatifs page={page} />
    default:
      return <AccordionContent page={page} />
  }
}

const AccordionContent = ({ page }) => (
  <div className="text-content accordion-content">
    <div
      className="headlines"
      dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
    />
    <div
      className="event-media media-text"
      dangerouslySetInnerHTML={{ __html: page.content }}
    />

    <Blocks page={page} />
  </div>
)

const AccordionPage = ({ page }) => {
  return (
    <section className="accordion-wrapper">
      {useSubPages(page.wordpress_id).map((item, index) => (
        <AccordionItem key={index} page={item}>
          <ItemContent page={item} />
        </AccordionItem>
      ))}
    </section>
  )
}

export default AccordionPage
